import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import api from '../utils/api';
import { Link } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Container, Card, Button, Form, Alert } from 'react-bootstrap';

const Register = () => {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [isOTPRequired, setIsOTPRequired] = useState(false); // State for OTP required checkbox
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const role = "tbd"; // to be determined - needs to be approved by admin

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Regular expression for email validation

    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address.');
      setLoading(false);
      return;
    }

    if (password.length < 10 || /\s/.test(password)) {
      setError('Password must be at least 10 characters and must not contain spaces.');
      setLoading(false);
      return;
    }

    if (name.length < 6 || /\s/.test(name)) {
      setError('Username must be at least 6 characters and must not contain spaces.');
      setLoading(false);
      return;
    }

    if (!recaptchaToken) {
      setError('Please complete the reCAPTCHA.');
      setLoading(false);
      return;
    }

    try {
      await api.post('/api/register', { name, email, password, phone, role, isOTPRequired, recaptchaToken });
      setSuccessMessage('Registration successful! Your request will be reviewed by an admin.');
      setName('');
      setEmail('');
      setPassword('');
      setPhone('');
      setIsOTPRequired(false); // Reset the checkbox to default
    } catch (error) {
      console.error('Register error:', error.response);
      if (error.response && error.response.status === 400) {
        setError('Email or username or phone already exists.');
      } else {
        setError('Registration failed. Please try again later.');
      }
    } finally {
      setLoading(false);
    }
  };

  const onReCAPTCHAChange = (token) => {
    setRecaptchaToken(token);
  };

  return (
    <Container className="mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <Card>
            <Card.Header>
              <h3 className="text-center">Register</h3>
            </Card.Header>
            <Card.Body>
              {error && <Alert variant="danger">{error}</Alert>}
              {successMessage && <Alert variant="success">{successMessage}</Alert>}
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="username" className="mb-3">
                  <Form.Label>Username <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    disabled={loading}
                    placeholder="Enter your username"
                  />
                   <Form.Text className="text-muted">
                    Username must be at least 6 characters long and no spaces allowed.
                  </Form.Text>
                </Form.Group>
                <Form.Group controlId="password" className="mb-3">
                  <Form.Label>Password <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={loading}
                    placeholder="Enter your password"
                  />
                  <Form.Text className="text-muted">
                    Password must be at least 10 characters long and no spaces allowed.
                  </Form.Text>
                </Form.Group>
                <Form.Group controlId="email" className="mb-3">
                  <Form.Label>Email <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={loading}
                    placeholder="Enter your email"
                  />
                  <Form.Text className="text-muted">
                    By providing your email, you consent to receive email messages from our app for one-time PIN verification and copy of donation receipt.
                  </Form.Text>
                </Form.Group>
                <Form.Group controlId="phone" className="mb-3">
                  <Form.Label>Phone <span className="text-danger">*</span></Form.Label>
                  <PhoneInput
                    country={'us'}
                    value={phone}
                    onChange={setPhone}
                    inputProps={{
                      name: 'phone',
                      required: true,
                      disabled: loading,
                    }}
                    enableSearch={true}
                    disableCountryCode={false}
                    placeholder="+1 (XXX) XXX-XXXX"
                    className="form-control"
                  />
                  <Form.Text className="text-muted">
                    By providing your phone number, you consent to receive SMS or WhatsApp messages from our app for one-time PIN verification.
                  </Form.Text>
                </Form.Group>
                <Form.Group controlId="otpRequired" className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Enable added security with OTP (One-Time Password)"
                    checked={isOTPRequired}
                    onChange={() => setIsOTPRequired(!isOTPRequired)}
                    disabled={loading}
                  />
                  {isOTPRequired && (
                    <Form.Text className="text-muted">
                      By checking this box, you consent to receive one-time PIN (OTP) messages via email, SMS, or WhatsApp for login verification.
                    </Form.Text>
                  )}
                </Form.Group>
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                  onChange={onReCAPTCHAChange}
                />
                <Button type="submit" variant="primary" className="w-100" disabled={loading}>
                  {loading ? 'Registering...' : 'Register'}
                </Button>
              </Form>
            </Card.Body>
          </Card>
          <p className="mt-3 text-center">
            Already have an account? <Link to="/login">Login here</Link>
          </p>
        </div>
      </div>
    </Container>
  );
};

export default Register;